export default {
  ACTION_UPDATE_MFA_STATUS: 'ACTION_UPDATE_MFA_STATUS',
  ACTION_UPDATE_MFA_CONFIRM: 'ACTION_UPDATE_MFA_CONFIRM',
  ACTION_SEND_MFA_CODE: 'ACTION_SEND_MFA_CODE',
  ACTION_REQUEST_NEW_CODE: 'ACTION_REQUEST_NEW_CODE',
  ACTION_CONFIRM_LOGIN_MFA: 'ACTION_CONFIRM_LOGIN_MFA',
  ACTION_SEND_NEW_CODE_MFA: 'ACTION_SEND_NEW_CODE_MFA',
  MUTATION_UPDATE_MFA_TYPE: 'MUTATION_UPDATE_MFA_TYPE',
  MUTATION_UPDATE_MFA_FLOW: 'MUTATION_UPDATE_MFA_FLOW',
  MUTATION_UPDATE_MFA_LOGIN: 'MUTATION_UPDATE_MFA_LOGIN',
  GETTER_MFA_DATA: 'GETTER_MFA_DATA',
  MUTATION_UPDATE_MFA_DATA: 'MUTATION_UPDATE_MFA_DATA'
};



// WEBPACK FOOTER //
// ./src/store/modules/mfa/constants.js